/// <amd-module name="Widgets/Burndown/BurnupWidget" />
import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { BurnDirection } from "./BurndownLegacyContracts";
import { BurndownWidget, LegacyBurndownWidget } from "./BurndownWidget";

/** This class has a silly but neccessary role, of differentiating from burndown widget, as burn direction isn't stored in widget settings! */
export class LegacyBurnupWidget extends LegacyBurndownWidget {
    protected getBurnDirection(): BurnDirection {
        return BurnDirection.Up;
    }
}

export class BurnupWidget extends BurndownWidget {
    protected getBurnDirection(): BurnDirection {
        return BurnDirection.Up;
    }
}

export class BurnupWidgetRenderer extends VssComponent<WidgetProps> {
    public render(): JSX.Element {
        return <BurnupWidget {...this.props} />;
    }
}

VssComponent.register("burnupWidget", BurnupWidgetRenderer);
